export enum ProductOrigin {
  National = 0,
  ForeignDirectImport = 1,
  ForeignPurchasedInDomesticMarket = 2
};
